<template>
    <div class="milestone">
        <img class="mile-bg-2" src="@/assets/index/milestone/bg1.png" alt="">
        
        <div class="mile-head show-page">
            <!-- <img class="mile-bg-1" src="@/assets/index/milestone/milestone1.png" alt=""> -->
            <div class="mile-bg-1" alt="">
                <img src="@/assets/index/milestone/milestone1.png" alt="">
                <img src="@/assets/index/milestone/milestone1.png" alt="">
            </div>

            <div class="pc-contain">
                <div class="t1 bold mile-title bounceUpIn">Milestones</div>
                <img class="mile-line zoomIn" src="@/assets/index/milestone/milestone2.png" alt="">
                <ul class="mile-list">
                    <li><div ref="runNum" class="list-title bounceUpIn" :style="`animation-delay:${getDt(0)}s`">Registered Users</div><div class="list-amount bounceUpIn" :style="`animation-delay:${getDt(1)}s`"><CountNum ref="runNumOne" :startNum=0 :toNum="mileData.registerUsers" /></div></li>
                    <li><div class="list-title bounceUpIn" :style="`animation-delay:${getDt(2)}s`">NFT Trade Volume</div><div class="list-amount bounceUpIn" :style="`animation-delay:${getDt(3)}s`"><CountNum ref="runNumTwo" :startNum=0 :toNum="mileData.nftTradeVolume" danwei="$" /></div></li>
                    <li><div class="list-title bounceUpIn" :style="`animation-delay:${getDt(4)}s`">NFTs Minted</div><div class="list-amount bounceUpIn" :style="`animation-delay:${getDt(5)}s`"><CountNum ref="runNumThree" :startNum=0 :toNum="mileData.nftMintAmount" /></div></li>
                    <li><div class="list-title bounceUpIn" :style="`animation-delay:${getDt(6)}s`">Most Expensive NFT Sold</div><div class="list-amount bounceUpIn" :style="`animation-delay:${getDt(7)}s`"><CountNum ref="runNumFour" :startNum=0 :toNum="mileData.mostExpensiveSold" danwei="$" /></div></li>
                </ul>
            </div>
        </div>

        <div class="mile-body show-page">
            <div class="sec-contain detail">
                <img class="pc-state mile-line-2 zoomIn" src="@/assets/index/milestone/milestone3.png" alt="">
                <img class="mobile-state mile-line-2 zoomIn" src="@/assets/index/milestone/mobileline.png" alt="">

                <div class="content">
                    <div class="t1 bold mile-title bounceUpIn">Vision</div>
                    <div class="mile-para">
                        <div class="h2 l-title bounceUpIn" :style="`animation-delay:${getContentDt(0)}s`">Free To Play, Play To Earn </div>
                        <div class="h3 bounceUpIn" :style="`animation-delay:${getContentDt(1)}s`">Users get rewarded for their engagement and enjoyment. A Metaverse combining Decentralized Finance and Games creating an ecosystem where developers, players, and collectors come together in one world.</div>
                    </div>
                    <div class="mile-para">
                        <div class="h2 l-title bounceUpIn" :style="`animation-delay:${getContentDt(2)}s`">Owned by Players </div>
                        <div class="h3 bounceUpIn" :style="`animation-delay:${getContentDt(3)}s`">Players get true ownership of their in-game assets. Utilizing the power of NFTs, assets you earn in games are owned by the player and lives forever on the blockchain.</div>
                    </div>
                    <div class="mile-para">
                        <div class="h2 l-title bounceUpIn" :style="`animation-delay:${getContentDt(4)}s`">Added-value for NFTs </div>
                        <div class="h3 bounceUpIn" :style="`animation-delay:${getContentDt(5)}s`">Assets can be used across the whole ecosystem.  With a focus on NFT interoperability, assets can be used in multiple games at the same time, creating a whole new world of fun.</div>
                    </div>

                    <div class="mobile-state mile-mobile-box">
                        <img class="bg slideInLeft" style="animation-delay:0.8s" src="@/assets/index/milestone/milestone4.png" alt="">
                        <img class="bird-1 rotateInS" style="animation-delay:1.1s" src="@/assets/index/milestone/milestone5.png" alt="">
                        <img class="bird-2 rotateInN" style="animation-delay:1.1s" src="@/assets/index/milestone/milestone6.png" alt="">
                        <img class="bird-3 rotateInS" style="animation-delay:1.1s" src="@/assets/index/milestone/milestone7.png" alt="">
                    </div>
                    
                    <div @click="toOldPage" class="miles-btn btn-1 bounceUpIn" :style="`margin-top:20px;animation-delay:${getContentDt(6)}s`">
                        Play Now
                    </div>
                </div>
            </div>

            <div class="pc-state right-box">
                <img class="bg slideInLeft" src="@/assets/index/milestone/milestone4.png" alt="">
                <img class="bird-1 rotateInS" style="animation-delay:0.3s" src="@/assets/index/milestone/milestone5.png" alt="">
                <img class="bird-2 rotateInN" style="animation-delay:0.3s" src="@/assets/index/milestone/milestone6.png" alt="">
                <img class="bird-3 rotateInS" style="animation-delay:0.3s" src="@/assets/index/milestone/milestone7.png" alt="">
            </div>

        </div>
    </div>
</template>

<script>
import CountNum from '@/components/CountNum';
import {OLDPAGE} from '@/utils/constant'
import { mapState } from "vuex";

export default {
    components:{
        CountNum
    },

    computed: {
		...mapState({
			mileData: (state) => state.globalState.mileData,
		}),
	},

    data(){
        return {
            liststart:0,
            listdt:0.08,

            contentstart:0.2,
            contentdt:0.1,
        }
    },

    mounted(){
        this.$refs.runNum.addEventListener("webkitAnimationStart", (e)=>{
            if(e.animationName == "landBounceUpIn"){
                this.$refs.runNumOne.startCount();
                this.$refs.runNumTwo.startCount();
                this.$refs.runNumThree.startCount();
                this.$refs.runNumFour.startCount();
            }
        })
    },

    methods:{
        toOldPage(){
            window.open(OLDPAGE)
        },  
        getDt(idx){
            return this.liststart + this.listdt*idx
        },
        getContentDt(idx){
            return this.contentstart + this.contentdt*idx
        },
    }
}
</script>

<style lang="less" scoped>
    .milestone{
        padding-top: 160px;
        overflow: hidden;
        position: relative;

        .mile-bg-2{
            position: absolute;
            bottom: 0;
            width: 100%;
        }

        // .mile-title{
        //     opacity: 0;
        //     // animation: landBounceIn 0.5s;
        // }

        .mile-head{
            width: 100%;
            text-align: center;
            position: relative;
    
            .mile-bg-1{
                position: absolute;
                width: 100%;
                left: 0;
                bottom: 55px;
                white-space: nowrap;

                img{
                    width: 100%;
                }

                animation: movestone 30s infinite linear;
            }
    
            .mile-line{
                margin: 25px 0;
                width: 100%;

                transform: scale(0);
            }
    
            .mile-list{
                list-style: none;
                margin: 0;
                padding: 0;
    
                li{
                    width: 25%;
                    display: inline-block;
                }
    
                .list-title{
                    font-weight: 100;
                    margin-bottom: 28px;
                    font-size: 30px;
                }
    
                .list-amount{
                    font-family: Poppins-b;
                    font-size: 49px;

                    span{
                        font-family: Poppins-b;
                        font-size: 49px;
                    }
                }
            }
        }

        .mile-body{
            position: relative;
            margin: 132px 0 153px 0;

            .detail{
                display: flex;
                align-items: center;
                width: 35%;

                .mile-title{
                    margin-bottom: 20px;
                }

                .mile-para{
                    padding: 20px 0;

                    .l-title{
                        font-weight: bold;
                        margin-bottom: 6px;
                    }
                }
                
                .mile-line-2{
                    height: 100%;
                    max-height: 525px;
                    margin-right: 45px;
                }

            }

            .right-box{
                position: absolute;
                width: 43%;
                max-width: 780px;
                right: 0;
                top: 50%;
                transform: translate(0, -50%);

                .bg{
                    width: 100%;
                }

                .bird-1{
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 20%;
                }
                .bird-2{
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 20%;
                }
                .bird-3{
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    width: 20%;
                }
            }

        }
    }

    @keyframes movestone {
        0% {
            left: 0;
        }
        100% {
            left: -100%;
        }
    }

</style>
